export default "__VITE_ASSET__C4ArE7Dp__"